import { txt } from "@/content/ContentContext";
import { useEffect, useState } from "react";
import { BarChart3, Boxes } from "lucide-react";
import { api } from "@/lib/api";
import { formatPlanPrice } from "@/lib/plans";
import { useContact } from "@/context/ContactContext";

export function AddonCard({ currency, tone = "light", code = "inventory" }) {
  const [addon, setAddon] = useState(null);
  const contact = useContact();
  useEffect(() => { api.get("/plans/addons").then((r) => setAddon(r.data.find((a) => a.code === code) || null)).catch(() => {}); }, [code]);
  if (!addon) return null;
  const price = addon.prices?.[currency];
  const dark = tone === "dark";
  return (
    <div className={`mt-6 flex flex-wrap items-center gap-4 rounded-2xl border border-dashed p-5 ${dark ? "border-white/20 text-white" : "border-slate-300 bg-white"}`} data-testid={`addon-${code}`}>
      <div className="grid h-11 w-11 place-items-center rounded-xl bg-amber-500 text-slate-950">{code === "reports" ? <BarChart3 className="h-5 w-5" /> : <Boxes className="h-5 w-5" />}</div>
      <div className="min-w-[220px] flex-1">
        <div className="flex items-center gap-2"><span className="font-display text-lg font-bold">{addon.name}</span><span className="rounded-full bg-slate-900 px-2 py-0.5 font-mono text-[10px] uppercase tracking-wider text-amber-400">{txt("landing.optional_extra")}</span></div>
        <p className={`text-sm ${dark ? "text-slate-400" : "text-slate-500"}`}>{addon.tagline}</p>
      </div>
      {price ? (
        <div className="font-mono" data-testid={`addon-${code}-price`}><span className="text-sm text-slate-500">{currency} </span><span className="text-2xl font-extrabold">{formatPlanPrice(price, currency)}</span><span className="text-sm text-slate-500">{txt("landing.month")}</span></div>
      ) : (
        <button onClick={() => contact("sales")} className="h-11 rounded-xl border-2 border-slate-900 px-4 text-sm font-bold hover:bg-slate-900 hover:text-white" data-testid={`addon-${code}-contact`}>{txt("landing.contact_sales")}</button>
      )}
    </div>
  );
}
